import { render, staticRenderFns } from "./UserTabSalaryHistory.vue?vue&type=template&id=6036f7b6"
import script from "./UserTabSalaryHistory.vue?vue&type=script&lang=js"
export * from "./UserTabSalaryHistory.vue?vue&type=script&lang=js"
import style0 from "./UserTabSalaryHistory.vue?vue&type=style&index=0&id=6036f7b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports